import { render } from "./ModalAddress.vue?vue&type=template&id=839b2dda&ts=true"
import script from "./ModalAddress.vue?vue&type=script&lang=ts"
export * from "./ModalAddress.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__